import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_BASE_URL } from '../config/api-base-url.token';
import type {
  BrandEmailTemplateDetailsResponse,
  BrandEmailTemplateListResponse,
  BrandListResponse,
  BrandSummary,
  CreateBrandPayload,
  GetBrandEmailTemplateDetailsPayload,
  ResetBrandEmailTemplateDetailsPayload,
  UpdateBrandPayload,
  UpdateBrandEmailTemplateDetailsPayload,
} from '../models/brand.models';

@Injectable({ providedIn: 'root' })
export class BrandApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  listBrands(): Observable<BrandListResponse> {
    return this.http.get<BrandListResponse>(`${this.baseUrl}/brands`);
  }

  getBrand(brandId: string): Observable<BrandSummary> {
    return this.http.get<BrandSummary>(`${this.baseUrl}/brands/${brandId}`);
  }

  createBrand(payload: CreateBrandPayload): Observable<BrandSummary> {
    return this.http.post<BrandSummary>(`${this.baseUrl}/brands`, payload);
  }

  updateBrand(brandId: string, payload: UpdateBrandPayload): Observable<BrandSummary> {
    return this.http.patch<BrandSummary>(`${this.baseUrl}/brands/${brandId}`, payload);
  }

  listBrandEmailTemplates(brandId: string): Observable<BrandEmailTemplateListResponse> {
    return this.http.get<BrandEmailTemplateListResponse>(`${this.baseUrl}/brands/${brandId}/email-templates`);
  }

  getBrandEmailTemplateDetails(
    brandId: string,
    payload: GetBrandEmailTemplateDetailsPayload,
  ): Observable<BrandEmailTemplateDetailsResponse> {
    return this.http.post<BrandEmailTemplateDetailsResponse>(
      `${this.baseUrl}/brands/${brandId}/email-templates/details`,
      payload,
    );
  }

  updateBrandEmailTemplateDetails(
    brandId: string,
    payload: UpdateBrandEmailTemplateDetailsPayload,
  ): Observable<BrandEmailTemplateDetailsResponse> {
    return this.http.put<BrandEmailTemplateDetailsResponse>(
      `${this.baseUrl}/brands/${brandId}/email-templates/details`,
      payload,
    );
  }

  resetBrandEmailTemplateDetails(
    brandId: string,
    payload: ResetBrandEmailTemplateDetailsPayload,
  ): Observable<BrandEmailTemplateDetailsResponse> {
    return this.http.delete<BrandEmailTemplateDetailsResponse>(
      `${this.baseUrl}/brands/${brandId}/email-templates/details`,
      {
        body: payload,
      },
    );
  }
}
